import type React from "react";

import { colorsPalettes } from "@similarweb/styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import LoaderGradient, {
    LOADER_GRADIENT_ID,
} from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Loader/LoaderGradient";

export const SearchBoxLoader: React.FC = () => (
    <Box
        width="100%"
        padding="16px 24px"
        borderBottom={`1px solid ${colorsPalettes.carbon["100"]}`}
        height="68px"
    >
        <PixelPlaceholderLoader
            width="100%"
            height={36}
            id={LOADER_GRADIENT_ID}
            ShapeMarkup={LoaderGradient}
        />
    </Box>
);
